<template>
  <div class="card" v-if="dendropdown.visibleFlag === true" style="height: 100%">
    <div class="card-header d-flex justify-content-between">
      <div class>{{dendropdown.vizTitle}}</div>

      <div>
        <select v-model="vehicleSelect" @change="select(vehicleSelect)" class="c-s">
          <option v-for="l1 in filtervehicle" v-bind:key="l1" v-bind:value="l1">{{l1}}</option>
        </select>
      </div>

      <a v-on:click="commentBox(dendropdown)" class="txt-color-white right-padding-50">
        <i class="fa fa-lg fa-comments"></i>
      </a>
    </div>
    <div class="card-body">
      <div :id="id" ref="r1c1"></div>
    </div>

    <b-modal ref="comment-box" @ok="postAnnotation()" :title="annotationTitle">
      <b-form-group label="Comment">
        <textarea rows="3" cols="40" v-model="cmnt" placeholder="Write a comment..."></textarea>
      </b-form-group>
    </b-modal>
  </div>
</template>
<script>
import {FwVizChartInfo} from "../models";
import axios from "axios";

export default {
  name: "Dendropdown",
  props: {
    dendropdown: Object
  },
  data: () => ({
    filtervehicle: "",
    vehicleData: [],
    vehicleSelect: [],
    l1: [],
    showModal: false,
    cmnt: "",
    annotations: [],
    searching: false,
    annotationTitle: "",
    id: `VIZ-${new Date().getTime()}`
  }),
  methods: {
    loadVehicleSummary: function() {
      axios.get("api/vehicletype-list/").then(
        res => {
          this.vehicleData = res.data;
          this.filtervehicle = Array.from(
            new Set(this.vehicleData.map(c => c.dim1).filter(x => x != null))
          );
         console.log("vehicleData",this.filtervehicle)
        },
        err => {
          console.log("Error in fetching record", err);
        }
      );
    },
    commentBox: function(what) {
      console.log(
        `ENTERED into the commentBox function(${what.menuName}, ${what.screenName})`
      );
      this.cmt = "";
      this.pg = what.menuName;
      this.section = what.screenTitle;
      this.annotationHeader = "User Annotations";
      this.annotationTitle =
        this.annotationHeader + "->" + this.pg + "->" + this.section;
      this.$refs["comment-box"].show();
    },

    postAnnotation: function() {
      const url = "/api/annotation";
      const data = {
        userId: 1,
        userName: "Admin",
        page: this.pg,
        section: this.section,
        comment: this.cmnt
      };
      axios.post(url, data).then(
        () => {
          this.$store.dispatch("loadAnnotations");
        },
        e => {
        //  this.$commonFn.auditLog(this.dendropdown.menuSyspk,menu, subMenu, "", "POST", e);
          console.error("error in updating annotations", e);
        }
      );
      let menu = this.pg;
      let subMenu = this.section;
      console.log("the menus and submenus for Audit log is", menu, subMenu);

     // this.$commonFn.auditLog(this.dendropdown.menuSyspk,menu, subMenu, "", "POST", "Success");
    },

    select: function(vehicleSelect) {
      console.log('dd','loading state');this.$store.dispatch("loadState").then(() => {
        let allVizType = this.$store.state.vizType;
        let v = this.dendropdown;
        let margin = {
          top: v.pmTop,
          right: v.pmRight,
          bottom: v.pmBottom,
          left: v.pmLeft
        };

        let vizId = v.vizTypeId;
        let filter = allVizType.filter(t => t.vizTypeId === vizId)[0];
        let vizname = filter.vizTypeName;
        let vizFunction = filter.vizTypeFunctionName;

        let divId = this.$refs.r1c1;

        let vizunit = v.positionLogical;

        let getChartInfo = vizunit => {
          let f = v;
          if (f.length === 0)
            return new FwVizChartInfo(vizunit, margin, {}, false, []);
          return new FwVizChartInfo(vizunit, margin, f, v.visibleFlag, f);
        };

        this.position = getChartInfo(vizunit);

        let chartData = this.position;
        console.log("The chart data is", chartData, vizname, divId);
      //  if (vehicleSelect != null)
          this.$commonFn.renderChartCompare(
            vizname,
            chartData,
            divId,
            vizFunction,
            vehicleSelect
          );
      });
    }
  },
  created() {
    this.loadVehicleSummary();
    this.select();
    console.log('dd-2','loading state');this.$store.dispatch("loadState").then(() => {
            let allVizType = this.$store.state.vizType;
            let v = this.dendropdown;
            let margin = {
              top: v.pmTop,
              right: v.pmRight,
              bottom: v.pmBottom,
              left: v.pmLeft
            };

            let vizId = v.vizTypeId;
            let filter = allVizType.filter(t => t.vizTypeId === vizId)[0];
            let vizname = filter.vizTypeName;
            let vizFunction = filter.vizTypeFunctionName;

            let divId = this.$refs.r1c1;

            let vizunit = v.positionLogical;

            let getChartInfo = vizunit => {
              let f = v;
              if (f.length === 0)
                return new FwVizChartInfo(vizunit, margin, {}, false, []);
              return new FwVizChartInfo(vizunit, margin, f, v.visibleFlag, f);
            };

            this.position = getChartInfo(vizunit);

            let chartData = this.position;
            console.log("The chart data is", chartData, vizname, divId);
            this.$commonFn.renderChartCompare(
                vizname,
                chartData,
                divId,
                vizFunction,
                '3S'
              );
          });
  }
};
</script>
<style>
.cobackground {
  fill: #eee;
}

text.active {
  fill: red;
}
.c-s {
  margin-top: -7px;
  margin-left: 500px;
  height: 30px;
}
</style>